
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...linkId]]",
      function () {
        return require("private-next-pages/[[...linkId]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...linkId]]"])
      });
    }
  